import React from "react";
import { useNavigate } from "react-router-dom";
const CtaSection = () => {
  const navigate = useNavigate();
  return (
    <section className="about_us_cta_section">
      {/* Background blur effects */}
      <div className="about_us_cta_section__bg">
        <div className="about_us_cta_section__blur about_us_cta_section__blur--top"></div>
        <div className="about_us_cta_section__blur about_us_cta_section__blur--bottom"></div>
      </div>

      {/* Content container */}
      <div className="about_us_cta_section__container">
        <div className="about_us_cta_section__content">
          <h2 className="about_us_cta_section__title">
            See how Simplifyte brings clarity to everyday work
          </h2>
          <p className="about_us_cta_section__description">
            For teams that want fewer follow-ups, stronger visibility, and
            smoother execution.
          </p>
          <div className="about_us_cta_section__buttons">
            <button
              className="about_us_cta_section__btn about_us_cta_section__btn--primary"
              onClick={() => navigate("/contactsales")}
            >
              Book a Demo
              <svg
                className="about_us_cta_section__btn_icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
            <button
              className="about_us_cta_section__btn about_us_cta_section__btn--secondary"
              onClick={() =>
                (window.location.href = "https://app.simplifyte.com/login")
              }
            >
              Start Free Trial
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
